import React from 'react';
import ColorEditor from '../ColorEditor';

const ContactEditor = ({ content, onContentChange, onArrayFieldChange, onAddArrayItem, onRemoveArrayItem, site, onCreateCustomTheme }) => {
  return (
    <div className="space-y-4">
      {/* Contact Elements */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Contact elements
        </label>
        <div className="space-y-2">
          {/* Section Heading Toggle */}
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700">Section heading</span>
            <div className="relative inline-block w-6 align-middle select-none transition duration-200 ease-in">
              <input 
                type="checkbox" 
                id="contactHeadingToggle"
                checked={content.showHeading !== false}
                onChange={(e) => onContentChange('showHeading', e.target.checked)}
                className="toggle-checkbox absolute block w-3 h-3 rounded-full bg-white border-2 appearance-none cursor-pointer"
              />
              <label htmlFor="contactHeadingToggle" className="toggle-label block overflow-hidden h-3 rounded-full bg-gray-300 cursor-pointer"></label>
            </div>
          </div>
          
          {/* Description Toggle */}
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700">Description</span>
            <div className="relative inline-block w-6 align-middle select-none transition duration-200 ease-in">
              <input 
                type="checkbox" 
                id="contactDescriptionToggle"
                checked={content.showDescription !== false}
                onChange={(e) => onContentChange('showDescription', e.target.checked)}
                className="toggle-checkbox absolute block w-3 h-3 rounded-full bg-white border-2 appearance-none cursor-pointer"
              />
              <label htmlFor="contactDescriptionToggle" className="toggle-label block overflow-hidden h-3 rounded-full bg-gray-300 cursor-pointer"></label>
            </div>
          </div>
          
          {/* Contact Info Toggle */}
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700">Contact info</span>
            <div className="relative inline-block w-6 align-middle select-none transition duration-200 ease-in">
              <input 
                type="checkbox" 
                id="contactInfoToggle"
                checked={content.showContactInfo !== false}
                onChange={(e) => onContentChange('showContactInfo', e.target.checked)}
                className="toggle-checkbox absolute block w-3 h-3 rounded-full bg-white border-2 appearance-none cursor-pointer"
              />
              <label htmlFor="contactInfoToggle" className="toggle-label block overflow-hidden h-3 rounded-full bg-gray-300 cursor-pointer"></label>
            </div>
          </div>
          
          {/* Contact Form Toggle */}
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700">Contact form</span>
            <div className="relative inline-block w-6 align-middle select-none transition duration-200 ease-in">
              <input 
                type="checkbox" 
                id="contactFormToggle"
                checked={content.showForm !== false}
                onChange={(e) => onContentChange('showForm', e.target.checked)}
                className="toggle-checkbox absolute block w-3 h-3 rounded-full bg-white border-2 appearance-none cursor-pointer"
              />
              <label htmlFor="contactFormToggle" className="toggle-label block overflow-hidden h-3 rounded-full bg-gray-300 cursor-pointer"></label>
            </div>
          </div>
          
          {/* Map Toggle */}
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-700">Map</span>
            <div className="relative inline-block w-6 align-middle select-none transition duration-200 ease-in">
              <input 
                type="checkbox" 
                id="contactMapToggle"
                checked={content.showMap !== false}
                onChange={(e) => onContentChange('showMap', e.target.checked)}
                className="toggle-checkbox absolute block w-3 h-3 rounded-full bg-white border-2 appearance-none cursor-pointer"
              />
              <label htmlFor="contactMapToggle" className="toggle-label block overflow-hidden h-3 rounded-full bg-gray-300 cursor-pointer"></label>
            </div>
          </div>
        </div>
      </div>

      {/* Section Content */}
      <div className="space-y-3">
        {/* Section Title */}
        {content.showHeading !== false && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Section Title</label>
            <input
              type="text"
              value={content.title || ''}
              onChange={(e) => onContentChange('title', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Get In Touch"
            />
          </div>
        )}

        {/* Description */}
        {content.showDescription !== false && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
            <textarea
              rows={3}
              value={content.description || ''}
              onChange={(e) => onContentChange('description', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
              placeholder="We'd love to hear from you. Send us a message and we'll respond as soon as possible."
            />
          </div>
        )}
      </div>

      {/* Contact Information */}
      {content.showContactInfo !== false && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">Contact Information</label>
          <div className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={content.email || ''}
                onChange={(e) => onContentChange('email', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="contact@business.com"
              />
            </div>
            
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Phone</label>
              <input
                type="tel"
                value={content.phone || ''}
                onChange={(e) => onContentChange('phone', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="+1 (555) 123-4567"
              />
            </div>
            
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Address</label>
              <textarea
                rows={2}
                value={content.address || ''}
                onChange={(e) => onContentChange('address', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                placeholder="123 Business Street, City, State 12345"
              />
            </div>
          </div>
        </div>
      )}

      {/* Form Configuration */}
      {content.showForm !== false && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-3">Form Configuration</label>
          <div className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Form Action URL</label>
              <input
                type="url"
                value={content.formAction || ''}
                onChange={(e) => onContentChange('formAction', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="https://formspree.io/f/your-form-id"
              />
              <p className="text-xs text-gray-500 mt-1">
                Use services like Formspree, Netlify Forms, or your own endpoint
              </p>
            </div>
            
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">Submit Button Text</label>
              <input
                type="text"
                value={content.submitButtonText || ''}
                onChange={(e) => onContentChange('submitButtonText', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Send Message"
              />
            </div>
          </div>
        </div>
      )}

      {/* Layout Options */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">Layout</label>
        <div className="space-y-2">
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Layout Style</label>
            <select
              value={content.layout || 'two-column'}
              onChange={(e) => onContentChange('layout', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="single-column">Single Column</option>
              <option value="two-column">Two Column</option>
              <option value="contact-left">Contact Info Left</option>
              <option value="contact-right">Contact Info Right</option>
            </select>
          </div>
          
          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">Text Alignment</label>
            <select
              value={content.textAlign || 'left'}
              onChange={(e) => onContentChange('textAlign', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </div>
        </div>
      </div>

      {/* Color Theme - Always at bottom */}
      <ColorEditor
        value={content.colorScheme || 'default'}
        onChange={(value) => onContentChange('colorScheme', value)}
        label="Section Color Theme"
        showReset={true}
        resetValue="default"
        siteTheme={site?.design?.colorTheme ? {
          name: site.design.colorThemeName || 'Site Theme',
          colors: site.design.colorTheme
        } : null}
        customThemes={site?.design?.customThemes || []}
        onCreateCustomTheme={onCreateCustomTheme}
      />
    </div>
  );
};

export default ContactEditor;